/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { FC } from "react";

import { LinkedRegistriesProps } from "./linked-registries.types";
import { LinkedRegistriesView } from "./linked-registries-view";
import { useLinkedRegistries } from "./use-linked-registries";

export const LinkedRegistries: FC<LinkedRegistriesProps> = ({
  showModal = true,
  openForm,
  setOpenForm,
  setSelectedRegistry,
  selectedRegistry,
}) => {
  const { refetchRegistries, canLinkRegistry, loading, linkedRegistries, showRegistryModal, linkedRegistryText } =
    useLinkedRegistries();

  return (
    <LinkedRegistriesView
      showModal={showModal}
      refetchRegistries={refetchRegistries}
      canLinkRegistry={canLinkRegistry}
      loading={loading}
      linkedRegistries={linkedRegistries}
      showRegistryModal={showRegistryModal}
      setOpenForm={setOpenForm}
      linkedRegistryText={linkedRegistryText}
      openForm={openForm}
      selectedRegistry={selectedRegistry}
      setSelectedRegistry={setSelectedRegistry}
    />
  );
};
